export type MetodoPago =
  | 'efectivo'
  | 'transferencia'
  | 'tarjeta_debito'
  | 'tarjeta_credito'
  | 'nequi'
  | 'daviplata'
  | 'pse'
  | 'cheque'
  | 'otro';

export type EstadoGasto = 'pagado' | 'pendiente' | 'cancelado';

export type FrecuenciaGasto =
  | 'semanal'
  | 'quincenal'
  | 'mensual'
  | 'bimestral'
  | 'trimestral'
  | 'anual';

export type CategoriaGasto =
  | 'arriendo'
  | 'servicios_publicos'
  | 'nomina'
  | 'proveedor'
  | 'transporte'
  | 'papeleria'
  | 'mercadeo'
  | 'impuestos'
  | 'mantenimiento'
  | 'otro';

export interface Proveedor {
  id: string;
  empresa_id: string;
  nombre: string;
  nit?: string | null;
  categoria?: string | null;
  telefono?: string | null;
  email?: string | null;
  direccion?: string | null;
  metodo_pago: MetodoPago;
  banco?: string | null;
  numero_cuenta?: string | null;
  titular_cuenta?: string | null;
  notas?: string | null;
  activo: boolean | null;
  created_at: string;
  updated_at: string;
}

export interface Gasto {
  id: string;
  empresa_id: string;
  usuario_id?: string | null;
  descripcion: string;
  categoria: CategoriaGasto;
  monto: number;
  fecha: string;
  metodo_pago: MetodoPago;
  estado: EstadoGasto;
  fecha_pago?: string | null;
  proveedor_id?: string | null;
  proveedor_nombre?: string | null;
  proveedor?: Pick<Proveedor, 'id' | 'nombre' | 'metodo_pago' | 'banco' | 'numero_cuenta'> | null;
  recurrente: boolean | null;
  frecuencia?: FrecuenciaGasto | null;
  dia_cobro?: number | null;
  gasto_padre_id?: string | null;
  recibo_url?: string | null;
  recibo_nombre?: string | null;
  recibo_mime?: string | null;
  deducible: boolean;
  notas?: string | null;
  activo: boolean | null;
  created_at: string;
  updated_at: string;
}

export interface PagoProveedor {
  id: string;
  empresa_id: string;
  proveedor_id: string;
  gasto_id?: string | null;
  monto: number;
  fecha: string;
  metodo_pago: MetodoPago;
  concepto?: string | null;
  referencia?: string | null;
  recibo_url?: string | null;
  estado: EstadoGasto;
  created_at: string;
}

export interface GastosResumen {
  empresa_id: string;
  /** Inicio de mes (timestamptz desde la vista). */
  mes: string;
  total_gastos: number;
  total_monto: number;
  monto_pagado: number;
  monto_pendiente: number;
  con_recibo: number;
  sin_recibo: number;
}

export interface NuevoGastoInput {
  descripcion: string;
  categoria: CategoriaGasto;
  monto: number;
  fecha: string;
  metodo_pago: MetodoPago;
  estado: EstadoGasto;
  fecha_pago?: string | null;
  proveedor_id?: string | null;
  proveedor_nombre?: string | null;
  recurrente: boolean;
  frecuencia?: FrecuenciaGasto | null;
  dia_cobro?: number | null;
  notas?: string | null;
  deducible?: boolean;
}

export const LABELS_CATEGORIA: Record<CategoriaGasto, string> = {
  arriendo: 'Arriendo',
  servicios_publicos: 'Servicios públicos',
  nomina: 'Nómina',
  proveedor: 'Proveedor',
  transporte: 'Transporte',
  papeleria: 'Papelería',
  mercadeo: 'Mercadeo',
  impuestos: 'Impuestos',
  mantenimiento: 'Mantenimiento',
  otro: 'Otro',
};

export const LABELS_METODO: Record<MetodoPago, string> = {
  efectivo: 'Efectivo',
  transferencia: 'Transferencia',
  tarjeta_debito: 'Tarjeta débito',
  tarjeta_credito: 'Tarjeta crédito',
  nequi: 'Nequi',
  daviplata: 'Daviplata',
  pse: 'PSE',
  cheque: 'Cheque',
  otro: 'Otro',
};
